import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { AuthorizationService } from "./services/authorization.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authorizationService: AuthorizationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === HttpStatusCode.Forbidden) {
          const code = error.error?.code;

          if (code === 'USER_NOT_REGISTERED') {
            this.authorizationService.logout();
          }
        }

        return throwError(() => error);
      })
    );
  }
}